<template>
    <div v-bind:class="['grp_wrap'+classSuffix, addClass, moreClass]">
        <div v-bind:class="['grp_title']" v-text="title" v-show="showGrpTitle"></div>
        <div v-bind:class="['grp_stand']" v-show="showGrpStand">
            {{ stand }} <span v-if="typeof source !== 'undefined' && source !== ''">({{ source }})</span>
        </div>
        <div v-bind:class="['grp_unit']" v-text="unit" v-show="showGrpUnit"></div>
        <div v-bind:class="['grp_source']" v-show="showGrpSource"></div>
        <div v-bind:class="[legendClass]" v-html="legend" v-show="isLegend && showGrpLegend"></div>
        <div v-bind:class="['grp_chart']"><canvas v-bind:id="'chart-'+chartSeq"></canvas></div>
    </div>
</template>

<script>
import axios from 'axios'
import Chart from 'chart.js';
import { $_WC } from '@/confs/common.const';

export default {
    /**
     * ver 2.0
     * 요청을 1회로 처리한다.
     *
     */
    data: function() {
        return {
            title: '',
            stand: '',
            unit: '',
            source: '',
            legend: '',
            isLegend: true,
            viewScale: Math.ceil(window.innerWidth / 1920),
            maxDate: '',
            addClass: [],
            legendClass: 'grp_legend',
            isAnimationOnComplete: false,
        }
    },
    props: {
        chartid: '',
        classSuffix: {
            type: String,
            default: ''
        },
        moreClass: {
            type: String,
            default: ''
        },
        params: '',
        chartTitle: '',
        chartStand: '',
        chartUnit: '',
        chartSource: '',
        chartKey: '',
        chartTitleSuffix: '',
        showGrpTitle: {
            type: Boolean,
            default: true,
        },
        showGrpStand: {
            type: Boolean,
            default: true,
        },
        showGrpUnit: {
            type: Boolean,
            default: true,
        },
        showGrpSource: {
            type: Boolean,
            default: true,
        },
        showGrpLegend: {
            type: Boolean,
            default: true,
        },
        showGrpValue: {
            type: Boolean,
            default: true,
        },
        fontColor: {
            type: String,
            default: '',
        },
    },
    created: function() {
    },
    computed: {
        chartSeq: function() {
            if(typeof this.chartKey !== 'undefined' && this.chartKey != '') {
                return this.chartKey;
            } else {
                return this.chartid;
            }
        },
    },
    mounted: function() {
        let vm = this;
        if(vm.chartid == "") {
            return;
        }
        let ctx = document.getElementById("chart-"+vm.chartSeq).getContext('2d');
        let chartUrl = $_WC.chartBaseURL + "/" + this.chartid;

        if(typeof this.params !== 'undefined' && this.params != '') {
            chartUrl += '?' + this.params;
        }

        axios.get(chartUrl).then(function(res) {

            let conf = res.data.config;
            let date = res.data.maxdate;
            let data = res.data.data;
            if(typeof date.basdtVal !== 'undefined') {
                vm.maxDate = date.basdtVal;
            }

            let proms = [];
            proms.push( vm.setChartConf(conf, data) );
            // Vue.nextTick(function () {
            Promise.all(proms).then(function(){
                data = vm.setChartData(conf, data);
                // console.log( data );
                conf.data.labels = data[conf.data.labelsColumnSeq];
                conf.data.datasets.forEach(function(dataset) {
                    // console.log(dataset);
                    if(conf.type == "doughnut" || conf.type == "pie") {
                        if(Array.isArray(dataset.dataKdHdngSqno)) {
                            let datas = [];
                            dataset.dataKdHdngSqno.forEach(function(sqno){
                                data[sqno].forEach(function(data){
                                    datas.push(data);
                                });
                            });
                            dataset.data = datas;
                            if(Array.isArray(dataset.label)) {
                                if(dataset.label.length > 1) {
                                    conf.data.labels = dataset.label;
                                } else {
                                    dataset.label = conf.data.labels;
                                }
                            }
                        } else {
                            dataset.data = data[dataset.dataKdHdngSqno];
                            dataset.label = conf.data.labels;
                        }
                    } else {
                        dataset.data = data[dataset.dataKdHdngSqno];
                    }
                });
                let ct = new Chart(ctx, conf);
                vm.legend = ct.generateLegend();
            });
        });
    },
    methods: {
        // 면적 차트 추가
    	hexToRgbArray(colorStr, opacity) {
            let el = document.createElement("div");
            el.style["background-color"] = colorStr;
            document.body.appendChild(el);
            let style = window.getComputedStyle(el);
            let color = style["backgroundColor"];
            document.body.removeChild(el);
            
            let colorArray = color.replace(/rgb\(/, "").replace(/\)/, "").split(",");
            if(typeof opacity !== 'undefined' && !isNaN(opacity)){
            	colorArray.push(opacity);            	
            }
            return colorArray;
        },
        setChartData: function(conf, data) {
            let vm = this;

            // 특수문자 처리
            if(conf.data.datasets.length > 0){
                conf.data.datasets.forEach(function(d,i){
                    if(typeof d.label !== 'undefined' && d.label !== ''){
                        conf.data.datasets[i].label = d.label.replace('&amp;middot;', '·');
                    }
                });
            }

            // 면적 차트 추가
        	conf.data.datasets.forEach(function(d,i){
    			if(typeof d.fill !== 'undefined' && d.fill === true){
	        		if(typeof d.fillOpacity !== 'undefined' && !isNaN(d.fillOpacity)){
	            		let rgbArray = vm.hexToRgbArray(d.backgroundColor, d.fillOpacity);
	            		if(rgbArray.length === 4){
	            			d.backgroundColor = 'rgba(' + rgbArray[0] + ',' + rgbArray[1] + ',' + rgbArray[2] + ',' + rgbArray[3] + ')';		
	            		} else if(rgbArray.length === 3){
	            			d.backgroundColor = 'rgba(' + rgbArray[0] + ',' + rgbArray[1] + ',' + rgbArray[2] + ')';
	            		}
	        		}
    			}
	        }); 

            // 백분율 추가
            if(conf.type == "doughnut" || conf.type == "pie") {
                if(typeof data['-2'] !== 'undefined') {
                    let totalVal = 0;
                    for(let key in data) {
                        if(Number(key) > 0) {
                            data[key].forEach(function(d){
                                totalVal += Number(d);
                            });
                        }
                    }
                    data['-2'].push(100 - totalVal);
                }
            }

            conf.data.datasets.forEach(function(dataset, i){
                if(dataset.type === 'line' && vm.viewScale > 1) {
                    dataset.borderWidth = Number(dataset.borderWidth) * 2;
                    // dataset.pointBorderWidth 점 크기는 설정 안하면 자동으로 같아짐
                }
            });

            // 코드형식 코드순서 정렬기능 추가
            if(typeof conf.options.codeSort !== 'undefined' && conf.options.codeSort === true) {
                if(typeof data['-9999'] !== 'undefined') {
                    let sortData = {};
                    for(let key in data) {
                        if(key !== '-9999') {
                            let sortList = [];
                            if(typeof sortList[key] === 'undefined') {
                                sortList[key] = [];
                            }
                            for(let i = 0; i < data[key].length; i++) {
                                let sortMap = {
                                    data: data[key][i],
                                    seq: Number(data['-9999'][i]),
                                };
                                sortList[key].push(sortMap);
                            }
                            for(let key in sortList) {
                                sortList[key].sort(function(pre, cur){
                                    return Number(pre.seq) > Number(cur.seq) ? 1 : Number(pre.seq) < Number(cur.seq) ? -1: 0;
                                });
                                if(typeof sortData[key] === 'undefined') {
                                    sortData[key] = [];
                                }
                                sortList[key].forEach(function(d){
                                    sortData[key].push(d.data);
                                });
                            }
                        }
                    }
                    data = sortData;
                }
            }

            // 높은 값 정렬
            if(typeof conf.options.upperSort !== "undefined" && conf.options.upperSort == true) {
                let axesSeq = conf.data.labelsColumnSeq;
                let sumList = [];
                for(let key in data) {
                    if(key == axesSeq || key == -9999) {
                        continue;
                    }

                    for(let i = 0; i < data[key].length; i++) {
                        if(typeof sumList[i] === "undefined") {
                            sumList[i] = {};
                            sumList[i].key = i;
                            sumList[i].value = 0;
                        }
                        let val = parseFloat(data[key][i]);
                        if(isNaN(val)) {
                            val = 0;
                        }
                        sumList[i].value += val;
                    }
                }
                sumList.sort(function(pre, cur){
                    return parseFloat(pre.value) > parseFloat(cur.value) ? -1 : parseFloat(pre.value) < parseFloat(cur.value) ? 1: 0;
                });

                let sortData = {};
                for(let key in data) {
                    sumList.forEach(function(v){
                        if(typeof sortData[key] === "undefined") {
                            sortData[key] = [];
                        }
                        sortData[key].push(data[key][v.key]);
                    });
                }
                data = sortData;
            }

            // 역순정렬 - 항상 최상위
            if(typeof conf.options.reverse !== "undefined") {
                if(conf.options.reverse == true) {
                    for(let d in data) {
                        data[d].reverse();
                    }
                }
            }

            // 사용자 정렬 추가
            if(typeof conf.options.customSort !== "undefined" && conf.options.customSort !== '') {
                let customLabelsColumnSeq = conf.data.labelsColumnSeq;
                let tmpCustomSort = conf.options.customSort.split(':');
                let customSortKeys = [];
                tmpCustomSort.forEach(function(d, idx){
                    data[customLabelsColumnSeq].forEach(function(d2, idx2){
                        if(d === d2){
                            customSortKeys.push(idx2);
                        }
                    });
                });

                if(customSortKeys.length > 0){
                    let customSortData = {};
                    for(let key in data) {
                        if(typeof customSortData[key] === "undefined") {
                            customSortData[key] = [];
                        }
                        customSortKeys.forEach(function(seq){
                            customSortData[key].push(data[key][seq]);
                        });
                    }
                    data = customSortData;
                }
            }

            conf.data.datasets.forEach(function(dataset, i){
                // 필드 연산 추가
                if(typeof dataset.mixDataKdHdng !== 'undefined' && dataset.mixDataKdHdng.length > 0) {
                    let mixDataKdHdngSqno = dataset.dataKdHdngSqno;
                    let mixDataVal = [];
                    dataset.mixDataKdHdng.forEach(function(mixData, mixIndex){
                        data[dataset.dataKdHdngSqno].forEach(function(v, index){
                            if(typeof mixDataVal[index] === 'undefined') {
                                mixDataVal[index] = 0;
                            }
                            let oldVal;
                            let newVal;
                            if(mixIndex === 0) {
                                oldVal = parseFloat(data[dataset.dataKdHdngSqno][index]);
                            } else {
                                oldVal = mixDataVal[index];
                            }

                            if(mixData.dataKdHdngSqno === 'input') {
                                // 입력 값으로 연산
                                newVal = parseFloat(mixData.inputValue);
                            } else {
                                // 필드 값으로 연산
                                newVal = parseFloat(data[mixData.dataKdHdngSqno][index]);
                            }
                            if(isNaN(oldVal)) {
                                oldVal = 0;
                            }
                            if(isNaN(newVal)) {
                                newVal = 0;
                            }
                            switch(mixData.operator) {
                                case "+" :
                                    mixDataVal[index] = oldVal + newVal;
                                    break;
                                case "-" :
                                    mixDataVal[index] = oldVal - newVal;
                                    break;
                                case "*" :
                                    mixDataVal[index] = oldVal * newVal;
                                    break;
                                case "/" :
                                    mixDataVal[index] = oldVal / newVal;
                                    break;
                            }
                        });
                    });

                    let newSqno = mixDataKdHdngSqno + '_mix';
                    if(typeof data[newSqno] === 'undefined') {
                        data[newSqno] = mixDataVal;
                        conf.data.datasets.forEach(function(d){
                            if(d.dataKdHdngSqno === mixDataKdHdngSqno && d.mixDataKdHdng.length > 0) {
                                d.dataKdHdngSqno = newSqno;
                            }
                        });
                    }
                }
            });

            // 누적기능
            conf.data.datasets.forEach(function(dataset, i){
                if(typeof dataset.accumulate !== 'undefined') {
                    if(typeof data[dataset.dataKdHdngSqno] !== 'undefined') {
                        if(dataset.accumulate === true) {
                            let accumulateVal = 0;
                            data[dataset.dataKdHdngSqno].forEach(function(v, index){
                                accumulateVal += parseFloat(v);
                                data[dataset.dataKdHdngSqno][index] = accumulateVal;
                            });
                        }
                    }
                }
            });

            // 데이터 포맷팅 - 누적 후 포맷팅하도록 수정
            conf.data.datasets.forEach(function(dataset, i){
                let digitFixed;
                if(conf.type == "doughnut" || conf.type == "pie") {
                    digitFixed = conf.data.datasets[0].digitFixed;
                } else {
                    digitFixed = dataset.digitFixed;
                }
                if(typeof digitFixed !== 'undefined') {
                    if(typeof data[dataset.dataKdHdngSqno] !== 'undefined') {
                        data[dataset.dataKdHdngSqno].forEach(function(v, index){
                            if(v != "") {
                                if(parseInt(digitFixed) < 0) {
                                    // 절사
                                    data[dataset.dataKdHdngSqno][index] = Math.floor(parseFloat(v) / (parseInt(digitFixed) * -1));
                                } else {
                                    // 소수처리
                                    data[dataset.dataKdHdngSqno][index] = parseFloat(v).toFixed(digitFixed);
                                }
                            }
                        });
                    }
                }
            });

            // 건너뛰기 기능 추가
            if(conf.options.stepSize !== 'undefined' && conf.options.stepSize > 1) {
                for(let key in data) {
                    let replaceData = [];
                    data[key].forEach(function(d, index){
                        if(index % conf.options.stepSize === 0) {
                            replaceData.push(d);
                        }
                    });
                    data[key] = replaceData;
                }
            }

            if (conf.type === 'bar') {
                conf.options.scales.yAxes.forEach(function (axe, axeIdx) {
                    if(typeof axe.ticks.customMiddleAlign !== 'undefined' && axe.ticks.customMiddleAlign
                        && typeof axe.ticks.max !== 'undefined' && axe.ticks.max > 0) {
                        axe.ticks.callback = function (value, index, values) {
                            if (index === 0) {
                                conf.options.scales.yAxes[axeIdx].ticks.min = axe.ticks.max * -1;
                            }
                            if (value >= 0) {
                                return value;
                            }
                        };
                    }
                });
            } else if(conf.type === 'horizontalBar') {
                conf.options.scales.xAxes.forEach(function (axe, axeIdx) {
                    if(typeof axe.ticks.customMiddleAlign !== 'undefined' && axe.ticks.customMiddleAlign
                        && typeof axe.ticks.max !== 'undefined' && axe.ticks.max > 0) {
                        axe.ticks.callback = function (value, index, values) {
                            if (index === 0) {
                                conf.options.scales.xAxes[axeIdx].ticks.min = axe.ticks.max * -1;
                            }
                            if (value >= 0) {
                                return value;
                            }

                        };
                    }
                });
            }

            // 특정바의 색상을 변경한다
            if(conf.type === 'bar' || conf.type === 'horizontalBar') {
                conf.data.datasets.forEach(function(dataset, i){
                    if(typeof dataset.replaceColorType !== 'undefined' && dataset.replaceColorType !== ''
                        && typeof dataset.replaceColor !== 'undefined') {
                        let defaultColor = dataset.backgroundColor;
                        let replaceColors = [];

                        if(dataset.replaceColorType === 'over'
                            && typeof dataset.replaceColorValue !== 'undefined'
                            && dataset.replaceColorValue !== '' && !isNaN(dataset.replaceColorValue)) {
                            // 특정 값 이상의 색상을 변경한다.
                            data[dataset.dataKdHdngSqno].forEach(function(v){
                                if(Number(v) >= Number(dataset.replaceColorValue)) {
                                    replaceColors.push(dataset.replaceColor);
                                } else {
                                    replaceColors.push(defaultColor);
                                }
                            });
                        } else if(dataset.replaceColorType === 'down') {
                            // 특정 값 이하의 색상을 변경한다.
                            data[dataset.dataKdHdngSqno].forEach(function(v){
                                if(Number(v) <= Number(dataset.replaceColorValue)) {
                                    replaceColors.push(dataset.replaceColor);
                                } else {
                                    replaceColors.push(defaultColor);
                                }
                            });
                        } else if(dataset.replaceColorType === 'max') {
                            // 가장 높은 값의 색상을 변경한다.
                            let replaceVal = Math.max.apply(null, data[dataset.dataKdHdngSqno]);
                            if(!isNaN(replaceVal)) {
                                data[dataset.dataKdHdngSqno].forEach(function(v){
                                    if(Number(replaceVal) === Number(v)) {
                                        replaceColors.push(dataset.replaceColor);
                                    } else {
                                        replaceColors.push(defaultColor);
                                    }
                                });
                            }
                        } else if(dataset.replaceColorType === 'min') {
                            // 가장 낮은 값의 색상을 변경한다.
                            let replaceVal = Math.min.apply(null, data[dataset.dataKdHdngSqno]);
                            if(!isNaN(replaceVal)) {
                                data[dataset.dataKdHdngSqno].forEach(function(v){
                                    if(Number(replaceVal) === Number(v)) {
                                        replaceColors.push(dataset.replaceColor);
                                    } else {
                                        replaceColors.push(defaultColor);
                                    }
                                });
                            }
                        } else if(dataset.replaceColorType === 'equal'
                            && typeof dataset.replaceColorValue !== 'undefined'
                            && dataset.replaceColorValue !== '') {
                            // 특정 기준 값의 색상을 변경한다
                            if(typeof data[conf.data.labelsColumnSeq] !== 'undefined') {
                                let replaceIdx = '';
                                data[conf.data.labelsColumnSeq].forEach(function(d, idx){
                                    if(d === dataset.replaceColorValue) {
                                        replaceIdx = idx;
                                    }
                                });
                                if(replaceIdx !== '') {
                                    data[dataset.dataKdHdngSqno].forEach(function(v, idx){
                                        if(idx === replaceIdx) {
                                            replaceColors.push(dataset.replaceColor);
                                        } else {
                                            replaceColors.push(defaultColor);
                                        }
                                    });
                                }
                            }
                        }

                        // 컬러변경이 있는 경우 세팅
                        if(replaceColors.length > 0) {
                            dataset.backgroundColor = replaceColors;
                            dataset.borderColor = replaceColors;
                            dataset.defaultColor = defaultColor;
                        }
                    }
                });
            }

            if(conf.data.labelsColumnSeq == "-1") {
                if(conf.type != "doughnut" && conf.type != "pie") {
                    // this.isLegend = false; // 기준이 없는 경우 범례를 보여줄 수 없다
                }
                let newData = {};
                let newDatasets = [];
                let backgroundColors = [];
                let labels = [];

                conf.data.datasets.forEach(function(dataset, i){

                    if(typeof newData[conf.data.labelsColumnSeq] === "undefined") {
                        newData[conf.data.labelsColumnSeq] = [];
                    }
                    newData[conf.data.labelsColumnSeq].push(dataset.label);

                    let val = 0;
                    data[dataset.dataKdHdngSqno].forEach(function(v){
                        val += parseFloat(v);
                    });

                    if(typeof newData[conf.data.datasets[0].dataKdHdngSqno] === "undefined") {
                        newData[conf.data.datasets[0].dataKdHdngSqno] = [];
                    }
                    newData[conf.data.datasets[0].dataKdHdngSqno].push(val);

                    if(i == 0) {
                        newDatasets.push(dataset);
                    }

                    if(typeof dataset.backgroundColor !== 'undefined' && dataset.backgroundColor != '') {
                        backgroundColors.push(dataset.backgroundColor);
                    }
                    if(typeof dataset.label !== 'undefined' && dataset.label != '') {
                        labels.push(dataset.label);
                    }
                });

                data = newData;
                if(conf.type != "doughnut" && conf.type != "pie") {
                    newDatasets[0].backgroundColor = backgroundColors;
                    newDatasets[0].borderColor = backgroundColors;
                    newDatasets[0].label = labels;
                }
                conf.data.datasets = newDatasets;
            }

            if(typeof conf.options.maxTicksLimit !== "undefined") {
                if(conf.options.maxTicksLimit > 0) {
                    let axesSeq = conf.data.labelsColumnSeq;
                    let limitData = {};
                    let sumData = {};
                    let overText = "";

                    let maxTicksType = 'front';
                    if(typeof conf.options.maxTicksType !== "undefined") {
                        maxTicksType = conf.options.maxTicksType;
                    }

                    if(typeof conf.options.maxTicksLimitOverText !== "undefined") {
                        if(conf.options.maxTicksLimitOverText != "") {
                            overText = conf.options.maxTicksLimitOverText;
                        }
                    }

                    for(let key in data) {
                        if(maxTicksType === 'back') {
                            data[key].reverse();
                        }
                        for(let i = 0; i < data[key].length; i++) {
                            if(i >= conf.options.maxTicksLimit) {
                                if(key == axesSeq && overText != "") {
                                    sumData[key] = overText;
                                } else {
                                    if(typeof sumData[key] === "undefined") {
                                        sumData[key] = 0;
                                    }
                                    sumData[key] += parseFloat(data[key][i]);
                                }
                            } else {
                                if(typeof limitData[key] === "undefined") {
                                    limitData[key] = [];
                                }
                                limitData[key].push(data[key][i]);
                            }
                        }
                        if(maxTicksType === 'back') {
                            limitData[key].reverse();
                        }
                    }

                    if(overText != "") {
                        for(let key in limitData) {
                            limitData[key].push(sumData[key]);
                        }
                    }
                    data = limitData;
                }
            }
            return data;
        },
        setChartConf: function(conf, chartData) {

            // 폰트 색상 변경 추가
            if(this.fontColor !== ''){
                conf.data.datasets.forEach(dataset => {
                    dataset.showValue.textColor = this.fontColor;
                });
                for(let key in conf.options.scales){
                    conf.options.scales[key].forEach(axes => {
                        axes.scaleLabel.fontColor = this.fontColor;
                        axes.ticks.fontColor = this.fontColor;
                    });
                }
            }

            if(typeof this.$parent.bindChartConfig === 'function') {
                this.$parent.bindChartConfig(conf);
            }

            if(conf.type === 'doughnut') {
                if(typeof conf.doughnut !== 'undefined' && typeof conf.doughnut.cutoutPercentage !== 'undefined') {
                    conf.options.cutoutPercentage = conf.doughnut.cutoutPercentage;
                }
            }
            // 파이차트 범례 우측나열 기능
            if(typeof conf.options.showRightLegend !== 'undefined' && conf.options.showRightLegend === true) {
                this.addClass.push('pie');
                this.legendClass = 'grp_legend2';
            }

            let hiddenDataKdHdngSqno = [];
            conf.data.datasets.forEach(function(dataset, index){
                if(typeof dataset.hidden !== 'undefined' && dataset.hidden === true) {
                    hiddenDataKdHdngSqno.push(dataset.dataKdHdngSqno);
                }
            });

            // 범례 노출 여부 추가
            if(typeof conf.options.hideLegend !== 'undefined' && conf.options.hideLegend === true) {
                this.isLegend = false;
            }
            // start: 증가 값 단위가 실수인 경우 모두 0일때 max값이 자동으로 1로 세팅되어 추가
            let totalVal = 0;
            conf.data.datasets.forEach(function(dataset){
                dataset.data.forEach(function(v){
                    totalVal += v;
                });
            });

            if(totalVal == 0) {
                if(conf.type == "bar" || conf.type == "line") {
                    conf.options.scales.yAxes.forEach(function(axes){
                        if(typeof axes.ticks.max === 'undefined'
                            && typeof axes.ticks.stepSize !== 'undefined'
                            && axes.ticks.stepSize != ''
                            && axes.ticks.stepSize.indexOf(".") > -1) {
                            axes.ticks.max = axes.ticks.stepSize * 5;
                        }
                    });
                } else if(conf.type == "horizontalBar") {
                    conf.options.scales.xAxes.forEach(function(axes){
                        if(typeof axes.ticks.max === 'undefined'
                            && typeof axes.ticks.stepSize !== 'undefined'
                            && axes.ticks.stepSize != ''
                            && axes.ticks.stepSize.indexOf(".") > -1) {
                            axes.ticks.max = axes.ticks.stepSize * 5;
                        }
                    });
                }
            }
            // end: 증가 값 단위가 실수인 경우 모두 0일때 max값이 자동으로 1로 세팅되어 추가

            // start: 기본색상지정
            conf.options.scales.xAxes.forEach(function(v){
                if(typeof v.barPercentag !== 'undefined' && v.barPercentag !== '' && !isNaN(v.barPercentag)) {
                    // 잘못 세팅한 차트 기본 값으로 변경
                    v.barPercentag = 0.9;
                }
                if(typeof v.scaleLabel.fontColor === "undefined") {
                    v.scaleLabel.fontColor = "#cacfd8";
                }
                if(typeof v.ticks.fontColor === "undefined") {
                    v.ticks.fontColor = "#cacfd8";
                }
                // 바 차트 두께 설정
                if(typeof v.barThickness !== 'undefined' && v.barThickness !== '' && !isNaN(v.barThickness)) {
                    v.maxBarThickness = v.barThickness - 1;
                    if(this.viewScale > 2) {
                        v.barThickness = v.barThickness * 2;
                        v.maxBarThickness = v.barThickness - 2;
                    }
                } else {
                    v.barThickness = 'flex';
                }
            }.bind(this));

            conf.options.scales.yAxes.forEach(function(v){
                if(typeof v.scaleLabel.fontColor === "undefined") {
                    v.scaleLabel.fontColor = "#cacfd8";
                }
                if(typeof v.ticks.fontColor === "undefined") {
                    v.ticks.fontColor = "#cacfd8";
                }
                // 바 차트 두께 설정
                if(typeof v.barThickness !== 'undefined' && v.barThickness !== '' && !isNaN(v.barThickness)) {
                    v.maxBarThickness = v.barThickness - 1;
                    if(this.viewScale > 2) {
                        v.barThickness = v.barThickness * 3;
                        v.maxBarThickness = v.barThickness - 3;
                    }
                } else {
                    v.barThickness = 'flex';
                }
            }.bind(this));
            // end: 기본색상지정

            if(conf.type == "bar" || conf.type == "line") {
                let newDatasets = [];
                conf.data.datasets.forEach(function(dataset) {
                    if(dataset.type == "") {
                        dataset.type = conf.data.datasets[0].type;
                    }
                    if(dataset.type == "line") {
                        newDatasets.push(dataset);
                    }
                });
                conf.data.datasets.forEach(function(dataset) {
                    if(dataset.type == "bar") {
                        newDatasets.push(dataset);
                    }
                });
                conf.data.datasets = newDatasets;
            }

            let displayMode = "pc";
            if(this.viewScale > 2) {
                displayMode = "did";
            }

            // 폰트 사이즈 조절..
            // Chart.defaults.global.defaultFontSize = 10 + (7 * (this.viewScale - 1));
            let labelLength = chartData[conf.data.labelsColumnSeq].length;
            if(typeof conf.options.stepSize !== 'undefined' && conf.options.stepSize !== ''){
               labelLength /= Number(conf.options.stepSize);
            }

            // let globalFontSize = 10 + (($_WC.responsiveScale-1)*2);
            let globalFontSize = 10
            if(labelLength > 20) {
                globalFontSize = 6;
            } else if(labelLength > 10){
                globalFontSize = 8;
            } else if(labelLength > 6){
                globalFontSize = 9;
            } else {
                globalFontSize = 10;
            }
            globalFontSize = globalFontSize + (($_WC.responsiveScale-1)*2);
            // globalFontSize = globalFontSize * $_WC.viewScale;
            if($_WC.viewScale === 2){
                globalFontSize = Math.round(globalFontSize * 1.8);
            }

            Chart.defaults.global.defaultFontSize = globalFontSize;

            let vm = this;
            if(typeof vm.chartTitle !== 'undefined' && vm.chartTitle != '') {
                vm.title = vm.chartTitle;
            } else {
                vm.title = conf.options.title.text;
            }
            if(typeof vm.chartTitleSuffix !== 'undefined' && vm.chartTitleSuffix != '') {
                vm.title += vm.chartTitleSuffix;
            }

            if(typeof vm.chartStand !== 'undefined' && vm.chartStand != '') {
                vm.stand = vm.chartStand;
            } else {
                if(typeof conf.options.chartStand !== 'undefined' && conf.options.chartStand != ''
                    && typeof vm.maxDate !== 'undefined'
                    && (conf.options.chartStand.toLowerCase().indexOf('yyyy') > -1
                        || conf.options.chartStand.toLowerCase().indexOf('mm') > -1
                        || conf.options.chartStand.toLowerCase().indexOf('dd') > -1
                        || conf.options.chartStand.toLowerCase().indexOf('qq') > -1)) {
                    let yyyy = '';
                    let mm = '';
                    let dd = '';
                    let qq = '';

                    if(conf.options.chartStand.toLowerCase().indexOf('yyyy') > -1) {
                        yyyy = vm.maxDate.substring(0,4);
                    }
                    if(conf.options.chartStand.toLowerCase().indexOf('mm') > -1) {
                        mm = vm.maxDate.substring(4,6);
                    }
                    if(conf.options.chartStand.toLowerCase().indexOf('dd') > -1) {
                        dd = vm.maxDate.substring(6,8);
                    }
                    if(conf.options.chartStand.toLowerCase().indexOf('qq') > -1) {
                        qq = vm.maxDate.substring(4,6);
                    }

                    let yearDelimiter = '년 ';
                    let monthDelimiter = '월 ';
                    let dayDelimiter = '일 ';
                    let quarterDelimiter = '분기 ';
                    if(typeof conf.standDelimiter !== 'undefined' && conf.standDelimiter !== '') {
                        yearDelimiter = '';
                        monthDelimiter = '';
                        dayDelimiter = '';
                        quarterDelimiter = '';
                        if(dd !== '') {
                            monthDelimiter = conf.standDelimiter;
                        }
                        if(mm !== '') {
                            yearDelimiter = conf.standDelimiter;
                        }
                        if(qq !== '') {
                            yearDelimiter = conf.standDelimiter;
                        }
                    }

                    let stand = "";
                    stand += (yyyy !== '' && conf.options.chartStand.toLowerCase().indexOf('yyyy') > -1) ? yyyy + yearDelimiter : '';
                    stand += (mm !== '' && conf.options.chartStand.toLowerCase().indexOf('mm') > -1) ? mm + monthDelimiter : '';
                    stand += (dd !== '' && conf.options.chartStand.toLowerCase().indexOf('dd') > -1) ? dd + dayDelimiter : '';
                    stand += (qq !== '' && conf.options.chartStand.toLowerCase().indexOf('qq') > -1) ? qq + quarterDelimiter : '';
                    stand += ' 기준';
                    vm.stand = stand;
                } else {
                    vm.stand = conf.options.chartStand;
                }
            }

            if(typeof vm.chartUnit !== 'undefined' && vm.chartUnit != '') {
                vm.unit = vm.chartUnit;
            } else {
                vm.unit = conf.options.chartUnit;
            }
            if(typeof vm.chartSource !== 'undefined' && vm.chartSource != '') {
                vm.source = vm.chartSource;
            } else {
                vm.source = conf.options.chartSource;
            }

            conf.options.title.display = false;
            conf.options.legend = {};
            conf.options.legend.display = false;
            conf.options.maintainAspectRatio = false;

            if(typeof conf.options.layout === "undefined") {
                conf.options.layout = {};
                let padding = {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0
                };

                if(conf.type == "bar" || conf.type == "line") {
                    padding.top = 20;
                } else if(conf.type == "horizontalBar") {
                    padding.right = 100;
                } else if(conf.type == "doughnut" || conf.type == "pie") {
                    padding.top = 20;
                    padding.bottom = 20;
                }
            }

            // 병합차트
            if(typeof conf.options.mergeDataKdHdngSqno !== "undefined") {
                if(conf.options.mergeDataKdHdngSqno != "") {
                    let i = -100;
                    conf.data.datasets.forEach(function(dataset) {
                        dataset.dataKdHdngSqno = ""+i;
                        i--;
                    });
                }
            }

            // 마우스 오버 툴팁 포멧 변경
            let callbacks = {};
            callbacks.label = function(tooltipItem, data) {
                if(conf.type == "bar" || conf.type == "line") {
                    if(typeof conf.options.mergeDataKdHdngSqno !== "undefined") {
                        let dataLabel;
                        if(conf.data.labelsColumnSeq == "-1") {
                            dataLabel = tooltipItem.label;
                            return dataLabel + ': ' + tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        }
                        dataLabel = data.datasets[tooltipItem.datasetIndex].label;
                        return dataLabel + ': ' + tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    }
                    return tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else if(conf.type == "horizontalBar") {
                    if(typeof conf.options.mergeDataKdHdngSqno !== "undefined") {
                        let dataLabel;
                        if(conf.data.labelsColumnSeq == "-1") {
                            dataLabel = tooltipItem.label;
                            return dataLabel + ': ' + tooltipItem.xLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        }
                        dataLabel = data.datasets[tooltipItem.datasetIndex].label;
                        return dataLabel + ': ' + tooltipItem.xLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    }
                    return tooltipItem.xLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else if(conf.type == "doughnut" || conf.type == "pie") {
                    let dataLabel = data.labels[tooltipItem.index];
                    let value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    if (Chart.helpers.isArray(dataLabel)) {
                        dataLabel = dataLabel.slice();
                        dataLabel[0] += value;
                    } else {
                        dataLabel += value;
                    }
                    return dataLabel;
                }
            };
            callbacks.afterBody = function(t, d){
                let index = t[0].index;
                if(hiddenDataKdHdngSqno.length > 0) {
                    let list = [];
                    hiddenDataKdHdngSqno.forEach(function(dataKdHdngSqno){
                        let map = {labelColors: '', label: '', data: ''};
                        d.datasets.forEach(function(dataset){
                            if(dataset.dataKdHdngSqno === dataKdHdngSqno) {
                                map.labelColors = dataset.backgroundColor;
                                map.label = dataset.label;
                                map.data = dataset.data[index];
                            }
                        });
                        list.push(map);
                    });
                    return list;
                }
            };
            conf.options.tooltips.callbacks = callbacks;

            conf.options.tooltips.enabled = false;
            conf.options.tooltips.custom = function(tooltipModel) {
                // Tooltip Element
                // let tooltipEl = document.getElementById('chartjs-tooltip');
                let tooltipEl = document.getElementById('chartjs-tooltip');

                // Create element on first render
                if (!tooltipEl) {
                    tooltipEl = document.createElement('div');
                    tooltipEl.id = 'chartjs-tooltip';
                    tooltipEl.style.opacity = 0;
                    tooltipEl.style.display = "none";
                    document.body.appendChild(tooltipEl);
                }

                // Hide if no tooltip
                if (tooltipModel.opacity === 0) {
                    tooltipEl.style.opacity = 0;
                    tooltipEl.style.display = "none";
                    return;
                }

                // Set caret Position
                tooltipEl.classList.remove('above', 'below', 'no-transform');
                if (tooltipModel.yAlign) {
                    tooltipEl.classList.add(tooltipModel.yAlign);
                } else {
                    tooltipEl.classList.add('no-transform');
                }

                function getBody(bodyItem) {
                    return bodyItem.lines;
                }

                let raceSize = tooltipModel.bodyFontSize;
                let fontSize = tooltipModel.bodyFontSize;

                // Set Text
                if (tooltipModel.body) {
                    let titleLines = tooltipModel.title || [];
                    let bodyLines = tooltipModel.body.map(getBody);

                    let innerHtml = '<caption>Chart</caption><thead>';

                    titleLines.forEach(function(title) {
                        innerHtml += '<tr><th style="color: #fff; text-align: left;">' + title + '</th></tr>';
                    });
                    innerHtml += '</thead><tbody style="text-align: left;">';
                    bodyLines.forEach(function(body, i) {
                        let colors = tooltipModel.labelColors[i];
                        let style = 'background:' + colors.backgroundColor;
                        style += '; border-color:' + colors.borderColor;
                        style += '; border-width: 2px';
                        style += '; width: ' + raceSize + 'px';
                        style += '; height: ' + raceSize + 'px';
                        style += '; display: inline-block';
                        let span = '<span style="' + style + '"></span>';
                        innerHtml += '<tr><td style="color: #fff">' + span + ' ' + body + '</td></tr>';
                    });

                    if(typeof tooltipModel.afterBody !== 'undefined' && tooltipModel.afterBody.length > 0) {
                        tooltipModel.afterBody.forEach(function(body){
                            if(body.labelColors !== '' && body.label !== '' && body.data !== '') {
                                let color = body.labelColors;
                                let style = 'background:' + color;
                                style += '; border-color:' + color;
                                style += '; border-width: 2px';
                                style += '; width: ' + raceSize + 'px';
                                style += '; height: ' + raceSize + 'px';
                                style += '; display: inline-block';
// let span = '<span style="' + style + '"></span>';
                                let span = '';  // 차트가 없으니 색상표기 하지 않음
                                innerHtml += '<tr><td style="color: #fff">' + span + ' ' + body.label + ': ' + body.data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); + '</td></tr>';
                            }
                        });
                    }
                    innerHtml += '</tbody>';
                    tooltipEl.innerHTML = '<table>' + innerHtml + '</table>';
                }

                let position = this._chart.canvas.getBoundingClientRect();

                let modelWidth = 0;
                if(position.width / 2 < tooltipModel.caretX) {
                    modelWidth = tooltipModel.width
                }

                let positionLeft = position.left + window.pageXOffset + tooltipModel.caretX - modelWidth;
                let positionTop = position.top + window.pageYOffset + tooltipModel.caretY - (tooltipModel.height / 2);

                // TODO 툴팁위치 추가 (차후 고려해본다)
// if(typeof conf.tooltipConf !== 'undefined') {
// if(typeof conf.tooltipConf.position !== 'undefined') {
// if(conf.tooltipConf.position === 'bottom') {
// if(conf.type == "bar" || conf.type == "line") {
// positionTop = position.bottom - position.top;
// } else if(conf.type == "horizontalBar") {
// positionLeft = position.left;
// }
// }
// }
// }

                // Display, position, and set styles for font
                tooltipEl.style.opacity = 0.9;
                tooltipEl.style.position = 'absolute';
                tooltipEl.style.left = positionLeft + 'px';
                tooltipEl.style.top = positionTop + 'px';
                tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
                tooltipEl.style.fontSize = fontSize + 'px';
                tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
                tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
                tooltipEl.style.pointerEvents = 'none';
                tooltipEl.style.zIndex = 10004;
                tooltipEl.style.backgroundColor = 'black';
                tooltipEl.style.borderRadius = '6px';
                tooltipEl.style.width = 'max-content';
                tooltipEl.style.display = "block";
            };

            // 축 데이터 포멧 변경
            if(conf.type == "bar" || conf.type == "line") {
                conf.options.scales.yAxes.forEach(function(yAxes){
                    yAxes.ticks.callback = function (value) {
                        if(value.toString().indexOf(".") == -1) {
                            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        } else {
                            return value.toString();
                        }
                    };
                });

                conf.options.scales.xAxes[0].ticks.callback = function (value) {
                    if(value != null) {
                        let length = value.length;
                        if(typeof conf.options.formmaterStart !== 'undefined' && conf.options.formmaterStart !== ''
                            && typeof conf.options.formmaterEnd !== 'undefined' && conf.options.formmaterEnd !== '') {
                            value = value.substring(conf.options.formmaterStart, conf.options.formmaterEnd);

                            if(typeof conf.options.formmaterLengthAddText !== 'undefined' && length > conf.options.formmaterEnd) {
                                value += conf.options.formmaterLengthAddText;
                            }
                        }

                        if(typeof conf.options.formmaterAddText !== 'undefined') {
                            value += conf.options.formmaterAddText;
                        }


                        if(typeof conf.options.formatter !== 'undefined') {
                            if(conf.options.formatter.length > 0) {
                                let newValue = "";
                                conf.options.formatter.forEach(function(formatter){
                                    if(!isNaN(formatter.start) && !isNaN(formatter.end)) {
                                        if(newValue != "") {
                                            if(typeof conf.options.formatTrim === 'undefined' || conf.options.formatTrim === false) {
                                                newValue += " ";
                                            }
                                        }
                                        newValue += value.substring(formatter.start, formatter.end) + formatter.addText;
                                    }
                                });
                                if(newValue != "") {
                                    value = newValue;
                                }
                            }
                        }
                    }
                    return value;
                };
            } else if(conf.type == "horizontalBar") {
                conf.options.scales.xAxes.forEach(function(xAxes){
                    xAxes.ticks.callback = function (value) {
                        if(value.toString().indexOf(".") == -1) {
                            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        } else {
                            return value.toString();
                        }
                    };
                });

                conf.options.scales.yAxes[0].ticks.callback = function (value) {
                    let length = value.length;
                    if(typeof conf.options.formmaterStart !== 'undefined' && conf.options.formmaterStart !== ''
                        && typeof conf.options.formmaterEnd !== 'undefined' && conf.options.formmaterEnd !== '') {
                        value = value.substring(conf.options.formmaterStart, conf.options.formmaterEnd);

                        if(typeof conf.options.formmaterLengthAddText !== 'undefined' && length > conf.options.formmaterEnd) {
                            value += conf.options.formmaterLengthAddText;
                        }
                    }

                    if(typeof conf.options.formmaterAddText !== 'undefined') {
                        value += conf.options.formmaterAddText;
                    }
                    return value;
                };
            }

            // showValue 애니메이션으로 변경
            let animationColors = [];
            conf.data.datasets.forEach(function (dataset, i) {
                if(dataset.showValue.display === true && vm.showGrpValue === true) {
                    let tmpAnimation = {};
                    if(typeof dataset.mixDataKdHdng !== 'undefined' && dataset.mixDataKdHdng.length > 0) {
                        tmpAnimation.key = dataset.dataKdHdngSqno + '_mix';
                    } else {
                        tmpAnimation.key = dataset.dataKdHdngSqno;
                    }
                    tmpAnimation.value = dataset.showValue.textColor;
                    animationColors.push(tmpAnimation);
                    dataset.showValue.display = false;
                }
            });

            // 동작이슈로 onComplete 이전에 선언한다
            if(conf.type === "doughnut" && typeof conf.doughnut !== 'undefined') {
                if(vm.viewScale > 1 && conf.doughnut.centerTextSize !== '') {
                    conf.doughnut.centerTextSize = Math.round(Number(conf.doughnut.centerTextSize) * 1.2);
                }
            }
            let animation = {};
            if(animationColors.length > 0) {
                animation.onComplete = function () {
                    let chartInstance = this.chart,
                        ctx = chartInstance.ctx;
                    ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'bottom';
                    if(conf.type == "horizontalBar") {
                        ctx.textAlign = 'left';
                    }

                    if(conf.type == "doughnut" || conf.type == "pie") {
                        let totalValue = 0;
                        let totalCount = 0;
                        let centerX = 0;
                        let centerY = 0;
                        if(conf.showValueConstant || conf.showValuePercent) {
                            this.data.datasets.forEach(function (dataset) {
                                for (let i = 0; i < dataset.data.length; i++) {
                                    totalValue += Number(dataset.data[i]);
                                    totalCount++;

                                    let model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model,
                                        total = dataset._meta[Object.keys(dataset._meta)[0]].total;

                                    centerX = model.x;
                                    centerY = model.y;

                                    let start_angle = model.startAngle;
                                    let end_angle = model.endAngle;
                                    let mid_angle = start_angle + (end_angle - start_angle)/2;
                                    let mid_radius;
                                    // 몇부터 외곽선에 표기할것 인지
                                    if(typeof conf.showValueOutline !== 'undefined' && parseInt(conf.showValueOutline) > 0) {
                                        if(Math.round(dataset.data[i]/total*100) < parseInt(conf.showValueOutline)) {
                                            let pad = 20 - Math.ceil(mid_angle  * 3);
                                            mid_radius = model.innerRadius + (model.outerRadius - model.innerRadius) + pad;
                                        } else {
                                            mid_radius = model.innerRadius + (model.outerRadius - model.innerRadius)/2;
                                        }
                                    } else {
                                        mid_radius = model.innerRadius + (model.outerRadius - model.innerRadius)/2;
                                    }

                                    let x = mid_radius * Math.cos(mid_angle);
                                    let y = mid_radius * Math.sin(mid_angle);

                                    ctx.fillStyle = animationColors[0].value;

                                    let data = "";
                                    if(parseFloat(dataset.data[i]) > 0) {
                                        if(conf.showValueConstant) {
                                            let val = parseFloat(dataset.data[i]);
                                            data += val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                        }
                                        if(conf.showValuePercent) {
                                            let percent = String(Math.round(dataset.data[i]/total*100)) + "%";
                                            if(data != "") {
                                                data += " ("+percent+")";
                                            } else {
                                                data += percent;
                                            }
                                        }
                                    }

                                    if(typeof conf.showValueRemove !== 'undefined' && parseInt(conf.showValueRemove) > 0) {
                                        if(Math.round(dataset.data[i]/total*100) >= parseInt(conf.showValueRemove)) {
                                            ctx.fillText(data, model.x + x, model.y + y);
                                        }
                                    } else {
                                        ctx.fillText(data, model.x + x, model.y + y);
                                    }
                                }
                            });

                            if(conf.type === "doughnut" && typeof conf.doughnut !== 'undefined') {
                                if(conf.doughnut.showCenterText) {
                                    let viewVal = totalValue;
                                    if(conf.doughnut.centerTextType === 'avg') {
                                        viewVal = (totalValue / totalCount).toFixed(2);
                                    }
                                    let size = Number(Chart.defaults.global.defaultFontSize) * Number(conf.doughnut.centerTextSize);
                                    let font = Chart.helpers.fontString(size, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
                                    ctx.font = font;
                                    let textY = centerY + (size / 2);

                                    if(typeof conf.doughnut.centerValdigitFixed !== 'undefined') {
                                        let digitFixed = conf.doughnut.centerValdigitFixed;
                                        if(typeof digitFixed !== 'undefined') {
                                            if(parseInt(digitFixed) < 0) {
                                                viewVal = Math.floor(parseFloat(viewVal) / (parseInt(digitFixed) * -1));
                                            } else {
                                                viewVal = parseFloat(viewVal).toFixed(digitFixed);
                                            }
                                        }
                                    }

                                    let text = viewVal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                    if(typeof conf.doughnut.centerAddText !== 'undefined') {
                                        text += conf.doughnut.centerAddText;
                                    }
                                    ctx.fillText(text, centerX, textY);
                                }
                            }
                        }
                    } else {
                        let datasetCount = this.data.datasets.length;
                        let dataValues = [];
                        let animationLabels = this.data.labels;
                        this.data.datasets.forEach(function (dataset, i) {
                            animationColors.forEach(function(color){
                                if(dataset.dataKdHdngSqno == color.key) {
                                    ctx.fillStyle = color.value;

                                    let meta = chartInstance.controller.getDatasetMeta(i);
                                    meta.data.forEach(function (bar, index) {
                                        let data = dataset.data[index].toString();
                                        let x = bar._model.x;
                                        let y = bar._model.y;

                                        if(conf.type == "bar" || conf.type == "line") {
                                            y = y - 5;
                                            // 상하 반전차트의 경우 위치조절
                                            conf.options.scales.yAxes.forEach(function(yAxe){
                                                if(typeof yAxe.ticks.reverse !== 'undefined' && yAxe.ticks.reverse) {
                                                    if(yAxe.id == dataset.yAxisID) {
                                                        y = y + 20;
                                                    }
                                                }
                                            });
                                            if(conf.stacked == true && conf.stackedValue != true) {
                                                let centerPoint = bar.getCenterPoint();
                                                x = centerPoint.x;
                                                y = centerPoint.y;
                                            }
                                        } else if(conf.type == "horizontalBar") {
                                            x = x + 4;
                                            y = y + 5;
                                            if (displayMode == "did") {
                                                x = x + 4;
                                                y = y + 8;
                                            }

                                            // 좌우 반전차트의 경우 위치조절
                                            conf.options.scales.xAxes.forEach(function(xAxe){
                                               if(typeof xAxe.ticks.reverse !== 'undefined' && xAxe.ticks.reverse) {
                                                   if(xAxe.id == dataset.xAxisID) {
                                                       if(vm.viewScale === 3) {
                                                           x = x - (40 + data.length + (data.length * (3 * vm.viewScale)));
                                                       } else {
                                                           x = x - (18 + data.length + (data.length * 3));
                                                       }
                                                   }
                                               }
                                            });

                                            if(conf.stacked == true && conf.stackedValue != true) {
                                                let centerPoint = bar.getCenterPoint();
                                                x = centerPoint.x;
                                                y = centerPoint.y+6;
                                                if (displayMode == "did") {
                                                    x = centerPoint.x;
                                                    y = centerPoint.y+13;
                                                }
                                            }
                                        }

                                        // 라인차트 값 상하단 표기
                                        if(typeof dataset.valuePosition !== 'undefined') {
                                            if(dataset.type === 'line' && dataset.valuePosition === 'bottom') {
                                                if(displayMode == "did") {
                                                    y = y + 40;
                                                } else {
                                                    y = y + 22;
                                                }
                                            }
                                        }

                                        if(Number(data) < 0) {
                                            if(dataset.type === 'bar') {
                                                if(displayMode == "did") {
                                                    y = y + 38;
                                                } else {
                                                    y = y + 20;
                                                }
                                            }
                                        }

                                        // 값 병합 추가
                                        if(conf.stacked == true && conf.stackedValue == true
                                            && (dataset.type == 'bar' || dataset.type == 'horizontalBar')) {
                                            if(data == "") {
                                                data = 0;
                                            }
                                            if(typeof dataValues[index] == 'undefined') {
                                                dataValues[index] = 0;
                                            }
                                            dataValues[index] += parseFloat(data);
                                            if(i == datasetCount - 1) {
                                                let val = parseFloat(dataValues[index]);
                                                let dataVal = val.toString();
                                                ctx.fillText(dataVal.replace(/\B(?=(\d{3})+(?!\d))/g, ","), x, y);
                                            }
                                        } else {
                                            if(data != "") {
                                                let val = parseFloat(data);
                                                data = val.toString();
                                            }

                                            // 값 표기 방식 추가
                                            if(typeof dataset.showValueType === 'undefined' || dataset.showValueType == '') {
                                                ctx.fillText(data.replace(/\B(?=(\d{3})+(?!\d))/g, ","), x, y);
                                            } else {
                                                // 최초 or 최종 값만 표기
                                                if(dataset.showValueType === 'first') {
                                                    if(index == 0) {
                                                        ctx.fillText(data.replace(/\B(?=(\d{3})+(?!\d))/g, ","), x, y);
                                                    }
                                                } else if(dataset.showValueType === 'last') {
                                                    if(index == meta.data.length - 1) {
                                                        ctx.fillText(data.replace(/\B(?=(\d{3})+(?!\d))/g, ","), x, y);
                                                    }
                                                } else if(dataset.showValueType === 'text') {
                                                    let labelSeq;
                                                    animationLabels.forEach(function(d, i){
                                                        if(d === dataset.showValueText) {
                                                            labelSeq = i;
                                                        }
                                                    });
                                                    if(typeof labelSeq !== 'undefined') {
                                                        if(index === labelSeq) {
                                                            ctx.fillText(data.replace(/\B(?=(\d{3})+(?!\d))/g, ","), x, y);
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    });
                                }
                            });
                        });
                    }
                    if(typeof vm.$eventBus !== 'undefined') {
                        if(!vm.isAnimationOnComplete) {
                            vm.$eventBus.$emit('GripChart:animation-onComplete', vm.chartid);
                        }
                        vm.isAnimationOnComplete = true;
                    }
                };
            } // if(animationColors.length > 0) {

            // 애니메이션 동작 수정 (값 표기 없는 경우 동작하지 못하는 오류 수정)
            if(typeof conf.options.animation !== 'undefined') {
                if(typeof conf.options.animation.easing !== 'undefined') {
                    animation.easing = conf.options.animation.easing;
                }
                if(typeof conf.options.animation.duration !== 'undefined') {
                    animation.duration = conf.options.animation.duration * 1000;
                } else {
                    animation.duration = 1000;
                }
            } else {
                animation.duration = 1000;
            }
            conf.options.animation = animation;
            conf.options.hover.animationDuration = 0;

            // click event 추가
            conf.options.onClick = function(event, item){
                if(typeof vm.$parent.clickChartListener === 'function') {
                    if(item.length == 1) {
                        let datasetIndex = item[0]._datasetIndex;
                        let index = item[0]._index;

                        let label = this.data.labels[index];
                        let data = this.data.datasets[datasetIndex].data[index];
                        let datasetLabel = this.data.datasets[datasetIndex].label;

                        if(Array.isArray(datasetLabel)) {
                            datasetLabel = datasetLabel[index];
                        }
                        vm.$parent.clickChartListener(
                            this.config.dataKdSqno, vm.chartid, label, data, datasetLabel, item[0]);
                    }
                }
            };

            let legendCallback = function(chart) {
                return vm.drawCustomLegend(chart);
            }
            conf.options.legendCallback = legendCallback;
        },
        drawCustomLegend: function(chart) {
            let text = [];
            for (let i = 0; i < chart.data.datasets.length; i++) {
                let dataset = chart.data.datasets[i];
                if(typeof dataset.hidden !== 'undefined' && dataset.hidden === true) {
                    continue;
                }
                let label = '';
                if(Array.isArray(dataset.label)) {
                    for (let j = 0; j < dataset.label.length; j++) {
                        label = dataset.label[j].trim();
                        if(typeof chart.options.legendFormatSt !== 'undefined' && typeof chart.options.legendFormatEd !== 'undefined'
                            && chart.options.legendFormatSt !== '' && chart.options.legendFormatEd !== ''){
                            label = label.substring(chart.options.legendFormatSt, chart.options.legendFormatEd).trim();
                            if(typeof chart.options.legendFormatAdd !== 'undefined' && chart.options.legendFormatAdd !== ''){
                                label += '' + chart.options.legendFormatAdd;
                            }
                        }
                        if(typeof chart.options.showValueLegend !== 'undefined' && chart.options.showValueLegend === true) {
                            text.push("<span><i style=\"background:" + dataset.borderColor[j] + "\"></i>" + label  + " (" + dataset.data[j].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ")</span>");
                        } else {
                            text.push("<span><i style=\"background:" + dataset.borderColor[j] + "\"></i>" + label  + "</span>");
                        }
                    }
                } else {
                    label = dataset.label.trim();
                    if(typeof chart.options.legendFormatSt !== 'undefined' && typeof chart.options.legendFormatEd !== 'undefined'
                        && chart.options.legendFormatSt !== '' && chart.options.legendFormatEd !== ''){
                        label = label.substring(chart.options.legendFormatSt, chart.options.legendFormatEd).trim();
                        if(typeof chart.options.legendFormatAdd !== 'undefined' && chart.options.legendFormatAdd !== ''){
                            label += '' + chart.options.legendFormatAdd;
                        }
                    }
                    // 특정 바의 색상을 변경한경우 범례는 default color 를 사용한다.
                    if(typeof dataset.defaultColor !== 'undefined') {
                        text.push("<span><i style=\"background:" + dataset.defaultColor + "\"></i>" + label + "</span>");
                    } else {
                        text.push("<span><i style=\"background:" + dataset.borderColor + "\"></i>" + label + "</span>");
                    }
                }
                if(typeof dataset.replaceColorType !== 'undefined') {
                    label = dataset.label.trim();
                    if(typeof chart.options.legendFormatSt !== 'undefined' && typeof chart.options.legendFormatEd !== 'undefined'
                        && chart.options.legendFormatSt !== '' && chart.options.legendFormatEd !== ''){
                        label = label.substring(chart.options.legendFormatSt, chart.options.legendFormatEd).trim();
                        if(typeof chart.options.legendFormatAdd !== 'undefined' && chart.options.legendFormatAdd !== ''){
                            label += '' + chart.options.legendFormatAdd;
                        }
                    }
                    if(dataset.replaceColorType === 'over' || dataset.replaceColorType === 'down') {
                        let addText = (dataset.replaceColorType === 'over') ? '이상' : '이하';
                        text.push("<span><i style=\"background:" + dataset.replaceColor + "\"></i>" + dataset.replaceColorValue + addText + " " + label + "</span>");
                    } else if(dataset.replaceColorType === 'max' || dataset.replaceColorType === 'min') {
                        // 최고 / 최소의 경우 범례를 추가하지 않는다.
                        // text.push("<span><i style=\"background:" +
                        // dataset.replaceColor + "\"></i>" + dataset.label +
                        // "</span>");
                    } else if(dataset.replaceColorType === 'equal') {
                        text.push("<span><i style=\"background:" + dataset.replaceColor + "\"></i> " + dataset.replaceColorValue + " " + label + "</span>");
                    }
                }
            }
            return text.join("");
        }
    }
}
</script>
